export default __webpack_public_path__ + "static/media/marker-pinpoint.72474f29.svg";